<h1>New Community</h1>

<customer-form [loading]="loading | async"
  (locationRequest)="locationRequest($event)"
  [location]="location$ | async"
  [locationLoading]="locationLoading$ | async"
  (submitted)="submitCustomer($event)"></customer-form>